<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加kpi"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="员工id：" prop="userId">
          <el-input v-model="detail.userId"></el-input>
        </el-form-item>

        <el-form-item label="kpi：" prop="kpi">
          <el-input-number
            v-model="detail.kpi"
            :min="0"
            :max="2"
            :step="0.1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'kpiCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {
        userId: '',
        kpi: ''
      },
      rules: {
        userId: {
          required: true,
          message: '请填写'
        },
        kpi: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  methods: {
    ...mapActions('kpi', ['add']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {
        distributionCoinType: 'FBS'
      };
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.add(this.detail).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
